import { useMemo } from 'react';
import { CallIntelUtils } from '@frontend/api-call-intel';
import { getUser } from '@frontend/auth-helpers';

// This hook will be later scaled to accomodate all demo data logic

/**
 * Hook to determine if the current user should see the demo view.
 * Returns true for demo users whose usernames include any entry in the demoAccounts list.
 */
export function useCallIntelWeaveDemoUser(): boolean {
  return useMemo(() => {
    const user = getUser();
    const username = user?.username?.toLowerCase() ?? '';

    return CallIntelUtils.isDemoUser(username);
  }, []);
}
